import calendar from './esm/doctor-calendar/doctor-calendar'
import branch from './esm/branch-select'
import filterPrices from './esm/filter-prices'

function initialize() {
  if ($('.b-clinic-employees').length) {
    calendar()
  }

  if ($('.b-tab-navigation__select_js_addresses').length) {
    branch()
  }

  if ($('.b-tab-navigation__select_js_price').length) {
    filterPrices()
  }

  if ($('a.license_image')[0]) {
    $('a.license_image').fancybox({
      loop: true,
      fitToView: false,
      scrolling: 'yes',
      autoScale: false,
      autoDimensions: false,
    })

    $('.js-license-fancybox').click(() => {
      $('a.license_image').first().click()
    })
  }

  if ($('a.license_image_mobile')[0]) {
    $('.js-license-fancybox').click(() => {
      $('.a_img.b-popup-photo-slider__preview').first().click()
    })
  }
}

document.addEventListener('DOMContentLoaded', initialize)
